import React, { useEffect, useState } from "react";
import FAQ from "../Pricing/FAQ";
import Footer from "../Footer";
import { PRICING_MID_BREAKPOINT, PRICING_MOBILE_BREAKPOINT } from "./constants";
import { StyledNav } from "./styles";
import SudowriteLogo from "../SudowriteLogo";
import useWindowSize from "../../hooks/useWindowSize";

const MainFAQ = ({ openLogin, showFront, hideFront }) => {
  const [ready, setReady] = useState(false);
  const [subscription, setSubscription] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentPlan, setCurrentPlan] = useState(false);
  const [nextPlan, setNextPlan] = useState(false);
  const [targetPlan, setTargetPlan] = useState(false);
  const [allPlans, setAllPlans] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const [isMobileView, setIsMobileView] = useState(false);
  const [isMidView, setIsMidView] = useState(false);

  const [outOfVersion, setOutOfVersion] = useState(false); // whether the user's current plan is not in the pricing version we're offering
  const [planInterval, setPlanInterval] = useState("year");
  const [user, setUser] = useState(null);

  const size = useWindowSize();

  const hasFreeTrial = subscription && subscription.activeTrial();
  const hasFreePlan = (subscription && currentPlan?.price === 0) || (subscription && nextPlan?.price === 0);

  useEffect(() => {
    showFront();

    return (() => {
      hideFront();
    });
  }, []);

  useEffect(() => {
    setIsMobileView(size.width < parseInt(PRICING_MOBILE_BREAKPOINT, 10));
    setIsMidView(size.width >= parseInt(PRICING_MOBILE_BREAKPOINT, 10) && size.width < parseInt(PRICING_MID_BREAKPOINT, 10));
  }, [size, isMobileView, isMidView]);

  return (
    <>
      <StyledNav>
        <SudowriteLogo
          isLink
          size="large"
          opacity={0.5}
        />

        <ul>
          <li>
            <a href={`${process.env.REACT_APP_MARKETING_PAGE_URL}/pricing`}>Pricing</a>
          </li>
          {!isMobileView && !user && openLogin && (
            <li>
              <a
                onClick={(e) => {
                  openLogin();
                }}
              >
                Log in
              </a>
            </li>
          )}
        </ul>
      </StyledNav>
      <section id="container">
        <FAQ questions="mainQuestions"></FAQ>
      </section>
      <Footer></Footer>
    </>
  );
};

export default MainFAQ;
